module.exports = __webpack_public_path__ + "static/img/obj6.9034bb80.png";